import {createActionCreators, ImmerReducer} from 'immer-reducer'
import {genericRequestError} from 'redux/toast/toast.duck'
import {TotalsStateType} from 'redux/totals/state'
import {getRaveUrlFilterData} from 'api/graphQL/queries/databases.queries'
import {Status} from 'commonTypes'
import {DatabaseMetadata} from 'graphql-api'

class TotalsGridSession extends ImmerReducer<TotalsStateType> {
  fetchFilterOptionsGO(){
    this.draftState.status = Status.PENDING
  }
  fetchFilterOptionsOK(databases: DatabaseMetadata[]){
    this.draftState.gridSession.filterOptions.raveUrl = databases
    this.draftState.status = Status.OK
  }
  fetchFilterOptionsERR(error){
    this.draftState.error = error
    this.draftState.status = Status.REJECTED
  }
}

export const fetchFilterOptions = () => async function(dispatch) {
  dispatch(TotalsGridSessionAC.fetchFilterOptionsGO())
  try {
    const {data} = await getRaveUrlFilterData()
    if (data?.databases?.length) {
      dispatch(TotalsGridSessionAC.fetchFilterOptionsOK(data?.databases))
    }
  } catch (err) {
    dispatch(genericRequestError())
    dispatch(TotalsGridSessionAC.fetchFilterOptionsERR(err))
  }
}

export const TotalsGridSessionAC = createActionCreators(TotalsGridSession)

export default TotalsGridSession
